import { Injectable } from "@angular/core";
import { BaseRestfulService, HttpVerb } from "../base-restful.service";
import { WhiteLabelSettings } from "./white-label.model";
import { Http } from "@angular/http";
import { Subject } from "rxjs";


@Injectable()
export class WhiteLabelService extends BaseRestfulService<WhiteLabelSettings> {
    whiteLabelDataSubject: Subject<WhiteLabelSettings> = new Subject<WhiteLabelSettings>();
    whiteLabelData: WhiteLabelSettings = null;

    private whiteLabelUrl = (clientId: string) => `reseller-config/api/v1/client/${clientId}/messagingui/whitelabelreseller`;

    constructor(protected _http: Http) {
        super(_http);
    }

    public getWhiteLabel(clientId: string) {
        const url = process.env.AppSettings.apiBaseUrl + this.whiteLabelUrl(clientId);

        this.callApimEndPoint(null, url, HttpVerb.Get)
            .subscribe(
                data => {
                    this.whiteLabelDataSubject.next(data);
                    this.whiteLabelData = data;
                },
                error => {
                    this.whiteLabelDataSubject.next(null);
                    this.whiteLabelData = null;
                    console.log('whitelabel data error:', error);
                },
                () => {
                    console.log('whitelabel data complete')
                });
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/my-settings/white-label/white-label.service.ts